import { createContext, useContext, useState, useCallback } from "react";

interface DatePickerContextType {
  openDatePicker: () => void;
  setDatePickerOpener: (opener: () => void) => void;
}

const DatePickerContext = createContext<DatePickerContextType | undefined>(
  undefined
);

export const DatePickerProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [datePickerOpener, setDatePickerOpener] = useState<
    (() => void) | undefined
  >(undefined);

  const openDatePicker = useCallback(() => {
    if (datePickerOpener) {
      datePickerOpener();
    }
  }, [datePickerOpener]);

  const setOpener = useCallback((opener: () => void) => {
    setDatePickerOpener(() => opener);
  }, []);

  return (
    <DatePickerContext.Provider
      value={{ openDatePicker, setDatePickerOpener: setOpener }}
    >
      {children}
    </DatePickerContext.Provider>
  );
};

export const useDatePickerContext = () => {
  const context = useContext(DatePickerContext);
  if (!context) {
    throw new Error(
      "useDatePickerContext must be used within DatePickerProvider"
    );
  }
  return context;
};

// Optional version that doesn't throw if context is unavailable
export const useOptionalDatePickerContext = () => {
  return useContext(DatePickerContext);
};
